import { ETTResistanceUIConfig } from "../../../../components/ui/ETTResistanceUI";
import { EttSpecialUIConfig } from "../../../../components/ui/EttSpecialUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import { BaseGeneralConfig, GeneralPartConfig } from "../../general-scenario-stuff";
import { GeneralStepCollection } from "../../GeneralStepCollection";
import GeneralProceduresEttPart1 from "./parts/GeneralProceduresEttPart1";

export default class GeneralProceduresEttMain extends GeneralStepCollection {
	private _parts: BaseScenarioPart<DaarcBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: GeneralProceduresEttMainConfig) {
		super();
		var context = this;
		context._parts.push(new GeneralProceduresEttPart1(this, config.scenario, () => {
			config.onDone();
		}, () => {
			if(config.onAbort) {
				config.onAbort();
			}
		}, context._partId1, config, () => {
			config.onDoneGoToEttOptimizations();
		}))
	}

	public start() {
		this.goToStep1();
	}

	goToStep1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface GeneralProceduresEttMainConfig extends BaseGeneralConfig {
	scenario: DaarcBaseScenario;
	part1Config?: GeneralProceduresEttPart1Config;
	unableToCompletePopup?: GeneralProceduresEttUnableToCompleteConfig;
	onChangeETTechnique?: () => void;
	onChooseAnotherTechniqueClicked?: () => void;
	onDone: () => void;
	onAbort: () => void;
	onDoneGoToEttOptimizations: () => void;
	ettResistanceConfig?: ETTResistanceUIConfig;
	isAttemptSuccessful: () => boolean;
	isTempSuccess: () => boolean;
}

export interface GeneralProceduresEttUnableToCompleteConfig {
	boxTitle: string;
	boxMessage: string;
}

export interface GeneralProceduresEttPart1Config extends GeneralPartConfig {
	attempt1AudioPath?: string;
	attempt2AudioPath?: string;
	attempt3AudioPath?: string;
	attempt4AudioPath?: string;
	ettSpecialUIConfig: EttSpecialUIConfig;
	hideVlButton?: () => boolean;
	onAbortClicked?: () => void;
	onEttInstrumentInsertionNextClicked?: (selectedIndex: number) => void;
	onEttSizeSelected?: (sizeSelected: string) => void;
	onMakeAttemptClicked?: (isDLClicked: boolean, isVLClicked: boolean) => void;
	onProcedureAttempted?: (attemptCount: number) => void;
	onProcedureAttemptedMoreThan3Times?: () => void;
	squeezeAmbuBagVideoChapter: () => string;
	insertingETTVideoChapter: () => string;
}